import { createReducer } from 'shared';
import { fetchQRCode } from 'redux/actions';

export const qrCodeEntitiesReducer = createReducer(
  {},
  {
    [fetchQRCode]: (entities, action) => ({ ...entities, ...action.entities }),
  }
);
